import { get } from '../../../json-transform';

export const patchEventImageField = (e, baseURL) => {
  // FIXME GUI-2836
  const img = e?.overview?.image;
  if (!img) return e;

  let url;
  try {
    // вырезаем из урла только путь, т.к. урл ведет на внешний контур
    const imgPath = new URL(img).pathname;
    // ...чтобы запросить картинку через наш прокси
    url = `${baseURL}${imgPath}`;
  } catch {
    url = img;
  }

  return {
    ...e,
    overview: {
      ...e?.overview,
      image: url,
    },
  };
};

export const baseGeneralEvent = (client) => ({
  event_type: get('event_type'),
  account_id: get('account_id'),
  event: get('event').as((event) => patchEventImageField(event, client.baseURL)),
});
